<template>
    <div class="v-icon mr-2 ">
        <v-dialog
            :value="editCourseDialog"
            max-width="500px"
            persistent
        >
            <v-card>
                <DialogTitle
                    :close="closeEditItem"
                    :dialog-name="dialogName"
                />
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex>
                                <v-select
                                    :error-messages="editCourseTypeIdErrors"
                                    :items="courseTypeList"
                                    item-text="name"
                                    item-value="id"
                                    @blur="$v.editCourseTypeId.$touch()"

                                    @input="$v.editCourseTypeId.$touch()"
                                    label="Course Type"
                                    v-model="editCourseTypeId"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Title"
                                    v-model="editTitle"
                                    :error-messages="editTitleErrors"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Description"
                                    v-model="editDescription"
                                    :error-messages="editDescriptionErrors"
                                />
                            </v-flex>                            
                            <v-flex>
                                <v-menu
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="290px"
                                    offset-y
                                    transition="scale-transition"

                                    v-model="startDateMenu"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            :error-messages="editStartDateErrors"
                                            @blur="$v.editStartDate.$touch()"
                                            @input="startDateMenu = false && $v.editStartDate.$touch()"
                                            label="Start Date"
                                            prepend-icon="event"
                                            readonly
                                            slot="activator"
                                            :value="editStartDate | formatDate"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        :error-messages="editStartDateErrors"
                                        @blur="$v.editStartDate.$touch()"
                                        @input="startDateMenu = false && $v.editStartDate.$touch()"
                                        no-title
                                        scrollable
                                        v-model="editStartDate"
                                    >
                                    <v-btn text color="primary" @click="() => {this.editStartDate = null}">Clear</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            
                            <v-flex>
                                <v-menu
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="290px"
                                    offset-y
                                    transition="scale-transition"

                                    v-model="endDateMenu"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            @blur="$v.editEndDate.$touch()"
                                            @input="endDateMenu = false && $v.editEndDate.$touch()"
                                            label="End Date"
                                            prepend-icon="event"
                                            readonly
                                            slot="activator"
                                            :value="editEndDate | formatDate"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        @blur="$v.editEndDate.$touch()"
                                        @input="endDateMenu = false && $v.editEndDate.$touch()"
                                        no-title
                                        scrollable
                                        v-model="editEndDate"
                                    >
                                    <v-btn text color="primary" @click="() => {this.editEndDate = null}">Clear</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            
                            <v-flex>
                                <v-menu
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="290px"
                                    offset-y
                                    transition="scale-transition"

                                    v-model="renewalDateMenu"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            @blur="$v.editRenewalDate.$touch()"
                                            @input="endDateMenu = false && $v.editRenewalDate.$touch()"
                                            label="Renewal Date"
                                            prepend-icon="event"
                                            readonly
                                            slot="activator"
                                            :value="editRenewalDate | formatDate"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        @blur="$v.editRenewalDate.$touch()"
                                        @input="renewalDateMenu = false && $v.editRenewalDate.$touch()"
                                        no-title
                                        scrollable
                                        v-model="editRenewalDate"
                                    >
                                    <v-btn text color="primary" @click="() => {this.editRenewalDate = null}">Clear</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>

                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-textarea
                                    label="Comments"
                                    v-model="editComments"
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <DialogActions
                    :close="closeEditItem"
                    :save="saveEditItemAndCloseDialog"
                />
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { SAVE_EDITED_PERSON_COURSE_BY_PERSON_ID } from "@/store/person_course/actions.js";
import { LOAD_PERSON_COURSE_TO_EDIT, RESET_DEFAULT_PERSON_COURSE_TO_EDIT, TOGGLE_EDIT_PERSON_COURSE_DIALOG, UPDATE_EDIT_PERSON_COURSE_FIELD } from "@/store/person_course/mutations";
import { required, } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from "vuex";
import DialogActions from "../../../../components/DialogActions";
import DialogTitle from "../../../../components/DialogTitle";
import { FETCH_PERSON_COURSE_LIST_BY_ID } from "../../../../store/person_course/actions";
import EditTableFunctions from './../../../ManagePersonnel/components/editTableFunctions';

    export default {
        name: "EditCourseDialog",

        validations: {
            editTitle: {required},
            editDescription: {required},
            editCourseTypeId: {required},
            editStartDate: {required},
        },

        components: {
            DialogActions,
            DialogTitle
        },

        mixins: [
            EditTableFunctions,
        ],

        data() {
            return {
                // Required for editTableFunctions
                idName: 'id',
                dialogName: 'Edit Course',
                startDateMenu: false,
                endDateMenu: false,
                renewalDateMenu: false,
            }
        },
        computed: {
            ...mapGetters(
                [
                    "courseTypeList",
                ]
            ),
            id: {
                get() {
                    return this.$store.state.person.person.personId;
                },
            },
            editCourseDialog: {
                get() {
                    return this.$store.state.person_course.editPersonCourseDialog;
                },
            },
            editTitle: {
                get() {
                    return this.$store.state.person_course.editPersonCourse.title;
                },
                set(value) {
                    this.updateValue('title', value);
                },
            },
            editTitleErrors() {
                const errors = [];
                if (!this.$v.editTitle.$dirty) return errors;
                !this.$v.editTitle.required && errors.push('required.');
                return errors
            },
            editDescription: {
                get() {
                    return this.$store.state.person_course.editPersonCourse.description;
                },
                set(value) {
                    this.updateValue('description', value);
                },
            },
            editDescriptionErrors() {
                const errors = [];
                if (!this.$v.editDescription.$dirty) return errors;
                !this.$v.editDescription.required && errors.push('required.');
                return errors
            },

            editCourseTypeId: {
                get() {
                    return this.$store.state.person_course.editPersonCourse.courseTypeId;
                },
                set(value) {
                    this.updateValue('courseTypeId', value);
                },
            },

            editCourseTypeIdErrors() {
                const errors = [];
                if (!this.$v.editCourseTypeId.$dirty) return errors;
                !this.$v.editCourseTypeId.required && errors.push('required.');
                return errors
            },

            editStartDate: {
                get() {
                    return this.$store.state.person_course.editPersonCourse.startDate;
                },
                set(value) {
                    this.updateValue('startDate', value);
                },
            },

            editStartDateErrors() {
                const errors = [];
                if (!this.$v.editStartDate.$dirty) return errors;
                !this.$v.editStartDate.required && errors.push('required.');
                return errors
            },

            editComments: {
                get() {
                    return this.$store.state.person_course.editPersonCourse.comments;
                },
                set(value) {
                    this.updateValue('comments', value);
                },
            },

            editEndDate: {
                get() {
                    return this.$store.state.person_course.editPersonCourse.endDate;
                },
                set(value) {
                    this.updateValue('endDate', value);
                },
            },

            editRenewalDate: {
                get() {
                    return this.$store.state.person_course.editPersonCourse.renewalDate;
                },
                set(value) {
                    this.updateValue('renewalDate', value);
                },
            },

            editPersonId: {
                get() {
                    return this.$store.state.person_course.editPersonCourse.personId;
                },
                set(value) {
                    this.updateValue('personId', value);
                },
            }
        },

        methods: {
            async validateAll() {

                this.$v.$touch();

                let formState = false;

                if (this.$v.$anyDirty === false) {
                    formState = 'clean';
                } else {
                    if (this.$v.$anyError === true) {
                        formState = 'error';
                    } else {
                        formState = 'complete';
                    }
                }

                let areValid = false;

                if (formState == 'complete') {
                    areValid = true;
                }

                return areValid;
            },

            ...mapActions({
                fetchItem: FETCH_PERSON_COURSE_LIST_BY_ID,
                updateTableItemRecord: SAVE_EDITED_PERSON_COURSE_BY_PERSON_ID,
            }),

            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_PERSON_COURSE_DIALOG,
                loadTableItemToEdit: LOAD_PERSON_COURSE_TO_EDIT,
                updateTableItemToEdit: UPDATE_EDIT_PERSON_COURSE_FIELD,
                resetEditItemToDefault: RESET_DEFAULT_PERSON_COURSE_TO_EDIT,
            }),

        },

    }
</script>

<style scoped>
</style>
